<template>
  <div class="journey">
<div class="flex">
<div class="container1">
<img class="mq" src="../../assets/bhut.png" alt="">
</div>
      <h3 >THE BACKGROUND</h3>
      <h1>Bhut</h1>
      <img src="../../assets/underline.png" alt="">

      <h4>
        Namaste. I’m Sabrina Merchant. This is the story of my <br> transformation from a Chartered Accountant into a full-fledged <br> yogapreneur. I came to the mat at an early age myself; yoga was <br> introduced to me at school. But the way it was being taught made it <br> feel immensely heavy. However, through the years and other fitness <br> activities, something kept bringing me back to yoga. <br> <br>
When I was juggling work responsibilities as a young mom, I began <br> to look for an activity for my daughter that was both stress-buster <br> and learning experience. But nothing of the sort could be found in <br> Mumbai! I decided to seize the day and pioneer kids’ yoga classes in <br> December 2018, in Mumbai. My goal was simple: transform the yoga <br> teaching experience and thus, transform the students.
      </h4>
      
</div>



<div class="flex1">
  <div class="container1">
  <img class="mq" src="../../assets/Vartaman.png" alt="">
  </div>
      <h3 >THE PRESENT JOURNEY</h3>
      <h1>Vartaman</h1>
      <img src="../../assets/underline.png" alt="">

      <h4>
       My first major roadblock was becoming apparent; if I hadn’t <br> connected with yoga as a child, then how would any other kid? <br> Fortunately, the right yoga teacher came into my life; she really <br> illuminated how much a mind-body connect can transform your life. <br> Now, armed with a 200-hour yoga teacher training certification and <br> my determination, I was ready to go the distance.  <br> <br>
Yoga was a lifelong tool that would vastly improve kids’ physical, <br> emotional and mental experiences. This was just how my guru had <br> reshaped my entire worldview. I threw myself into designing first-of <br>  -their-kind classes to fire up young minds and calm little hearts. The <br> sessions were based on kids’ needs and boundless energy. <br> <br>
With Lil Yogis, I’ve been curriculum head for yoga at DIY X Kyt <br> Academy and was featured on television on Mother’s Menu for the <br> Living Foodz channel. I even helped Radio One’s RJ Annie and her <br> listeners celebrate International Yoga Day with my expertise. Within <br> one short year, I found I had organically passed on my knowledge to <br> over ten thousand little ones!
      </h4>
</div>

<div class="flex2">
   <div class="container1">
  <img class="mq" src="../../assets/Bhavishya.png" alt="">
  </div>
      <h3 >THE FUTURE</h3>
      <h1>Bhavishya</h1>
      <img src="../../assets/underline.png" alt="">

      <h4>
      Before the pandemic, our lessons were in the invigorating sea air. <br> With the onset of Covid-19, we went online; now kids as far away as <br> Singapore, Hong Kong and even Europe joined us! We look forward <br> to making a big difference to hundreds of parents and kids <br> internationally, propagating this deep cultural knowledge. 
      </h4>
</div>



  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.mq{
  display: none;
}
.journey{
background: url(../../assets/journey.png);
    height: 339vh;
    background-repeat: no-repeat;
    background-position: inherit;
    background-position-y: 199px;
    background-position-x: -1113px;
      margin-top: -417px;
}
.flex{
        display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: space-around;
    height: 471px;
    text-align: center;
    /* margin-top: 150px; */
    position: relative;
    top: 741px;
    left: 79px;
    text-align: start;
    width: 600px;
}
.flex1{
        display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: space-around;
    height: 620px;
    text-align: center;
    /* margin-top: 150px; */
    position: relative;
    top: 964px;
    left: 982px;
    text-align: start;
    width: 600px;
}
.flex2{
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: space-around;
    height: 286px;
    text-align: center;
    /* margin-top: 150px; */
    position: relative;
    top: 1339px;
    left: 79px;
    text-align: start;
    width: 600px;
}
h3{
    color: white;
    font-weight: 450;
}
h1{
     font-size: 3rem;
    font-weight: 500;
    font-family: 'Original Surfer', cursive;
    color: white;
}
h4{
    color: white;
    font-weight: 500;
    line-height: 150%;
}

@media (max-width:1650px){
  .mq{
  display: block;
  width: 35%;
  margin: auto;
}
  .journey{
    background: none;
    background-color: #60993E ;
    height: auto;
   
  }
  .flex{
    position: unset;
    align-items: center;
    margin-top: 500px !important;
        height: 695px;
            width: 80%;
    margin: auto;
        
  }
  .flex1{
    align-items: center;
    position: unset;
    /* margin-top: 943px; */
            height: 811px;
            margin-top: 67px !important;
            width: 80%;
    margin: auto;
  }
  .flex2{
    align-items: center;
    position: unset;
            height: 505px;
                margin-top: 67px !important;
                width: 80%;
    margin: auto;
  }
}
@media (max-width:600px){
 .flex{
   height: 949px;
 }
  .flex1{
    height: 1158px;
  }
}


</style>